import React from "react";

type PreOrderPriceType = {
  price: string;
  discount?: string;
};

const PreOrderPrice = ({ price, discount }: PreOrderPriceType) => {
  return (
    <div>
      <span>{price}</span>
      {discount && (
        <span>
          <br />
          {discount}
        </span>
      )}
    </div>
  );
};

export default PreOrderPrice;
